import { render, staticRenderFns } from "./ReturnGoodsDetail.vue?vue&type=template&id=64008fba&scoped=true"
import script from "./ReturnGoodsDetail.vue?vue&type=script&lang=js"
export * from "./ReturnGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./ReturnGoodsDetail.vue?vue&type=style&index=0&id=64008fba&prod&lang=css"
import style1 from "./ReturnGoodsDetail.vue?vue&type=style&index=1&id=64008fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64008fba",
  null
  
)

export default component.exports